import { TrendingUp, Handshake, Rocket, Globe2 } from "lucide-react";

const benefits = [
  {
    Icon: TrendingUp,
    title: "Markt im Umbruch",
    desc: "Der europäische Bausektor (rund 1,6 Billionen EUR) sucht aktiv nach skalierbaren, klimapositiven Alternativen — Holzbau wächst überdurchschnittlich.",
  },
  {
    Icon: Rocket,
    title: "Erste Prototypen gebaut",
    desc: "Das System ist nicht nur Konzept: Erste Prototypen validieren Statik, Fertigung und Montage in der Praxis.",
  },
  {
    Icon: Handshake,
    title: "Industriepartner statt IP-Schlacht",
    desc: "Wir setzen auf Geschwindigkeit. Ziel ist die schnelle industrielle Umsetzung mit erfahrenen Fertigungs- und Bauunternehmen — keine langwierigen Patent- oder IP-Spiele.",
  },
  {
    Icon: Globe2,
    title: "Regulatorischer Rückenwind",
    desc: "EU-Taxonomie, ESG-Mandate und nationale Klimaziele machen ehrlichen Holzbau zur strategischen Notwendigkeit.",
  },
];

const Investment = () => {
  return (
    <section
      id="investment"
      data-testid="investment-section"
      className="relative py-24 md:py-36 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <span data-testid="investment-eyebrow" className="label-eyebrow">
              Marktpotenzial
            </span>
            <h2 className="font-heading mt-6 text-4xl sm:text-5xl font-light leading-[1.05] tracking-tighter">
              Ein Markt, der
              <br />
              <span className="text-[#c88a53] italic font-extralight">
                jetzt kippt.
              </span>
            </h2>
            <p className="mt-8 text-base md:text-lg text-white/65 leading-relaxed font-light">
              MONOWOOD adressiert den europäischen Bausektor (rund 1,6
              Billionen EUR) in strukturellem Wandel. Unser Ziel: schnelle
              industrielle Umsetzung mit den richtigen Partnern — auf Basis
              bereits gebauter Prototypen.
            </p>
          </div>

          <div className="md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 items-stretch">
              {benefits.map((b, i) => (
                <div
                  key={i}
                  data-testid={`investment-benefit-${i}`}
                  className="bg-[#0a0a0a] p-8 group hover:bg-[#0f0f0f] transition-colors flex flex-col"
                >
                  <div className="w-10 h-10 flex items-center justify-center border border-white/10 group-hover:border-[#c88a53]/60 transition-colors">
                    <b.Icon size={18} className="text-[#c88a53]" strokeWidth={1.4} />
                  </div>
                  <h3 className="mt-6 font-heading text-lg md:text-xl text-white font-medium tracking-tight">
                    {b.title}
                  </h3>
                  <p className="mt-3 text-sm text-white/55 leading-relaxed flex-1">
                    {b.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Investment;
